import { useContext } from 'react';

import { AppContext } from '@/app.context';
import { NAVBAR_ICON_URL, NAVBAR_ICON_DARK_URL } from '@/constants';

/**
 * The navbar/topbar logo URL for the app's current color scheme, read off
 * the general AppContext (not a template's own context) so any template can
 * pick this up without duplicating the light/dark branch itself.
 * NAVBAR_ICON_DARK_URL always resolves to a real file (prepare.ts falls back
 * to the light icon's own bytes when a tenant has no dark variant), so this
 * never needs an existence check of its own.
 */
export function useNavbarIconUrl(): string {
	const { colorScheme } = useContext(AppContext);
	return colorScheme === 'dark' ? NAVBAR_ICON_DARK_URL : NAVBAR_ICON_URL;
}
